import { useAppSelector } from "../utils/hooks";
import { lookupTranslation } from "../utils/TextTranslate";

export function useTranslateText() {
  const map = useAppSelector((state) => state.LanguageTextList?.data?.map);
  const mapNorm = useAppSelector(
    (state) => state.LanguageTextList?.data?.mapNorm,
  );

  return (text: string): string => lookupTranslation(map, mapNorm, text);
}
